import { ChangeEvent, memo, useCallback } from 'react';

import MenuItem from '@material-ui/core/MenuItem';

import { Select } from '../../select/Select';
import { TextArea } from '../../textArea/TextArea';
import { AttachmentItem } from '../attachmentItem/AttachmentItem';
import { useStyles } from './NewAttachmentCard.styles';
import { NewAttachmentCardProps } from './NewAttachmentCard.types';

export const NewAttachmentCard = memo(
  ({
    attachment,
    attachmentTypes,
    showTypeSelect,
    disabled,
    onPreview,
    onDelete,
    onChangeType,
    onChangeDescription,
  }: NewAttachmentCardProps) => {
    const styles = useStyles();

    const handleTypeChange = useCallback(
      (event: ChangeEvent<{ name?: string; value: unknown }>) => {
        const selectedTypeId = event.target.value as number;
        const type = attachmentTypes?.find(t => t.id === selectedTypeId) || null;

        onChangeType(type);
      },
      [attachmentTypes, onChangeType],
    );

    const handleDescriptionChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        onChangeDescription(event.target.value);
      },
      [onChangeDescription],
    );

    return (
      <div className={styles.root}>
        <AttachmentItem
          name={attachment.name}
          fileUrl={attachment.url}
          disabled={disabled}
          onPreview={onPreview}
          onDelete={onDelete}
        />

        {showTypeSelect && (
          <Select
            value={attachment.typeOfAttachment?.name ? attachment.typeOfAttachment.id : ''}
            label="Type of attachment"
            variant="outlined"
            disabled={disabled}
            onChange={handleTypeChange}
          >
            {attachmentTypes?.map(type => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </Select>
        )}

        <TextArea
          value={attachment.description ?? ''}
          label="Description"
          variant="outlined"
          size="medium"
          fullWidth
          disabled={disabled}
          onChange={handleDescriptionChange}
        />
      </div>
    );
  },
);
